import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=027894b5&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupComponent.vue?vue&type=style&index=0&id=027894b5&prod&lang=scss&scoped=true"
import style1 from "./PopupComponent.vue?vue&type=style&index=1&id=027894b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027894b5",
  null
  
)

export default component.exports